import React from 'react'
import { useLocation } from 'react-router-dom'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useFetchList } from 'store'
import { Options } from 'models'

const PresetProtocolsFilters = () => {
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)

	const bodyPartsUri = '/metadata/trust_body_parts'
	const injuryTypesUri = 'metadata/injuries_types'

	const {
		contents: [bodyParts, injuries],
	} = useFetchList(
		[bodyPartsUri, injuryTypesUri],
		[Options.fromSimpleObjectJSON, Options.fromSimpleObjectJSON],
		60000 * 60 // One hour
	)

	const acutePhaseOptions = [
		{
			value: '',
			text: i18n`Any`,
		},
		{
			value: 'true',
			text: i18n`Yes`,
		},
		{
			value: 'false',
			text: i18n`No`,
		},
	]

	const bodyPartOptions = [
		{
			value: '',
			text: i18n`Any`,
		},
		...(bodyParts || []),
	]

	const injuryOptions = [
		{
			value: '',
			text: i18n`Any`,
		},
		...(injuries || []),
	]

	return (
		<HStack align='center' justify='space-between' gap='xsmall'>
			<HStack
				align='center'
				justify='flex-start'
				wrap='nowrap'
				gap='xsmall'
				columns={[1, 1, 1]}
			>
				<Dropdown
					name='bodyPartId'
					placeholder={i18n`Body Part`}
					searchable
					value={queryParams?.bodyPart ?? ''}
					options={bodyPartOptions || []}
					onChange={(e) => {
						setQueryParams({
							page: undefined,
							segment: undefined,
							bodyPart: e.target.value,
						})
					}}
				/>
				<Dropdown
					name='injuryId'
					placeholder={i18n`Injury Type`}
					searchable
					value={queryParams?.injury ?? ''}
					options={injuryOptions || []}
					onChange={(e) => {
						setQueryParams({
							page: undefined,
							segment: undefined,
							injury: e.target.value,
						})
					}}
				/>
				<Dropdown
					name='acutePhase'
					placeholder={i18n`Acute Phase`}
					searchable
					value={queryParams?.acutePhase ?? ''}
					options={acutePhaseOptions || []}
					onChange={(e) => {
						setQueryParams({
							page: undefined,
							segment: undefined,
							acutePhase: e.target.value,
						})
					}}
				/>
			</HStack>
		</HStack>
	)
}

export default PresetProtocolsFilters
